import { required, optional, obj } from 'AppReact/schema';

const address = {
    address: required('string'),
    city: required('string'),
    state: required('string'),
    zip: required('string'),
}

const addressError = {
    addressError: optional('string'),
    cityError: optional('string'),
    stateError: optional('string'),
    zipError: optional('string'),
}

export default {
    name: required('string'),
    number: required('string'),
    email: required('string'),
    address: obj(address),
    current: required('boolean'),
    rent: required('boolean'),

    hasError: optional('boolean'),
    emailError: optional('string'),
    numberError: optional('string'),
    addressError: obj(addressError),
}


export const defaultcurrentResidency = {
    name: '',
    number: '',
    email: '',
    address: {
        address: '',
        city: '',
        state: '',
        zip: ''
    },
    current: true,
    rent: true,


    hasError: false,
    emailError: '',
    numberError: '',
    addressError: {
        addressError: '',
        cityError: '',
        stateError: '',
        zipError: ''
    },
}
